import { connect } from "react-redux";
import ConfigurationAndTesting from "./configurationAndTesting";
import { bindActionCreators } from "redux";
import {
  configurationAndTestingChecklist,
  postConfigurationAndTesting
} from "services/redux/installation/civilCheckList/action";
import { getGateInfo } from "services/redux/installation/handOver/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  configurationAndTesting: state.civilReducer.configAndTesting,
  gateInfo: state.handOverReducer.gateInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      configurationAndTestingChecklist,
      getGateInfo,
      documentUploadUrl,
      postConfigurationAndTesting
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ConfigurationAndTesting);
